import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'


export const publicRoutes = [

    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
      key: 'connecter',
      path: `${AUTH_PREFIX_PATH}/login/login`,
      component: React.lazy(() => import('views/auth-views/authentication/login/login')),
  },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'verify-email',
        path: `${AUTH_PREFIX_PATH}/verify-email`,
        component: React.lazy(() => import('views/auth-views/authentication/verify-email')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: "user.manageAccount",
        path: `${APP_PREFIX_PATH}/account/*`,
        component: React.lazy(() => import("views/app-views/account")),
    },
    {
        key: "Employees",
        path: `${APP_PREFIX_PATH}/employees/`,
        component: React.lazy(() => import("views/app-views/employees")),
    },
    {
        key: "Paiement",
        path: `${APP_PREFIX_PATH}/employees/:id/paiement`,
        component: React.lazy(() =>
            import("views/app-views/employees/paiement")
        ),
    },
    {
      key :"creches-supplement",
      path: `${APP_PREFIX_PATH}/creches/supplement/`,
      component:React.lazy(() => import("views/app-views/creche/supplement")),
      
    },
    {
      key :"creches-authorizations",
      path: `${APP_PREFIX_PATH}/creches/authorization/`,
      component:React.lazy(() => import("views/app-views/creche/authorization")),
      
    },
    {
      key :"Creches-section-age",
      path: `${APP_PREFIX_PATH}/creches/AgeSection/`,
      component:React.lazy(() => import("views/app-views/creche/AgeSection")),
      
    },
    {
      key :"Creches-types-depenses",
      path: `${APP_PREFIX_PATH}/creches/depensestypes/`,
      component:React.lazy(() => import("views/app-views/creche/depensestypes")),
      
    },
    {
      key: 'Creches-liste-dipenses',
      path: `${APP_PREFIX_PATH}/creches/dipenses`,
      component: React.lazy(() => import("views/app-views/creche/ListeDipenses")),
  
    },
    {
      key :"Creches-categories-abonnement",
      path: `${APP_PREFIX_PATH}/creches/SubscriptionCategories/`,
      component:React.lazy(() => import("views/app-views/creche/SubscriptionCategories")),
      
    },
    {
      key: "Classes",
      path: `${APP_PREFIX_PATH}/Classes/`,
      component: React.lazy(() => import("views/app-views/Classes")),
  },
      {
        key: 'Childrens',
        path: `${APP_PREFIX_PATH}/Childrens/`,
        component: React.lazy(() => import("views/app-views/Childrens")),
      }, 
      {
        key: 'Needs',
        path: `${APP_PREFIX_PATH}/Needs/`,
        component: React.lazy(() => import("views/app-views/gestionBesoins/Needs")),
      }, 
      {
        key: 'purchases',
        path: `${APP_PREFIX_PATH}/purchases/`,
        component: React.lazy(() => import("views/app-views/gestionBesoins/purchases")),
      },

      {
        key: "FactureChild",
        path: `${APP_PREFIX_PATH}/Childrens/:id/Factures`,
        component: React.lazy(() =>
            import("views/app-views/Childrens/Factures/invoice-list") 
        ),
    },
      {
          key: 'Finances Enfants',
          path: `${APP_PREFIX_PATH}/FinancesEnfants/`,
          component: React.lazy(() =>
            import("views/app-views/FinancesEnfants") 
        ),
        }, 
          {
              key: 'gestionBesoins',
              path: `${APP_PREFIX_PATH}/gestionBesoins/`,
              component: React.lazy(() =>
                import("views/app-views/gestionBesoins") 
            ),
            }, 
            {
              key: 'gestionUsers',
              path: `${APP_PREFIX_PATH}/gestionUsers/`,
              component: React.lazy(() =>
                import("views/app-views/gestionUsers") 
            ),
            }, 
    
    

]

